import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { InfoButton } from '@/domain/mitarbeiter/shared/components/InfoButton';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import {
  auszahlungsgrenzeEinheitAuswahl,
  AuszahlungsgrenzeEinheitAuswahl,
} from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/auszahlungsgrenzeEinheitAuswahl';
import { Heading, RadioGroup, RadioGroupItem } from '@e2n/ui/v2';
import { faCircleEuro, faClock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function AuszahlungsgrenzeEinheit() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-1 items-center">
        <Heading>
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeEinheit.description',
          )}
        </Heading>
        <InfoButton>
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeEinheit.info',
          )}
        </InfoButton>
      </div>
      <form.AppField
        name="bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeEinheit"
        listeners={{
          onChange: () => {
            ctx.resetDependentFields(
              'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeEinheit',
            );
          },
        }}>
        {(field) => (
          <FieldBase>
            <RadioGroup
              value={field.state.value}
              onValueChange={(e) =>
                field.handleChange(e as AuszahlungsgrenzeEinheitAuswahl)
              }
              className="flex flex-row">
              <RadioGroupItem
                variant="card"
                layout="horizontal"
                icon={<FontAwesomeIcon icon={faCircleEuro} />}
                label={t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeEinheit.options.euro',
                )}
                value={auszahlungsgrenzeEinheitAuswahl.euro}
                className="w-full"
              />
              <RadioGroupItem
                variant="card"
                layout="horizontal"
                icon={<FontAwesomeIcon icon={faClock} />}
                label={t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeEinheit.options.stunden',
                )}
                value={auszahlungsgrenzeEinheitAuswahl.stunden}
                className="w-full"
              />
            </RadioGroup>
          </FieldBase>
        )}
      </form.AppField>
    </div>
  );
}
